<div class="EXTRA_SERVICE_FLIGHTS_FORM modal-header w-100 d-inline-block border-bottom pb-0 mb-0">
    <div class="d-flex justify-content-between">
      <h4 class="booking-modal-title">Long Term Rental or Relocation</h4>
      <p class="modal-clost-btn" (click)="bsModalRef?.hide()" aria-label="Close">&times;</p>
    </div>
    <div>
    </div>
  </div>
  <div class="modal-body p-4 mt-3">
   <p class="my-3 intro">Our team are available on the go to assist & support with your Long Term Rental or Relocation request.</p>
    <form [formGroup]="form">
        <div class="form-group mb-3">
            <label class=" form-label">
              Location <span class="text-danger">*</span>
            </label>
            <div class="row">
                <div class="col-12 form-input">
                    <app-location-selector className="input-locator" placeholder="Enter location" [showErrorMsg]="false"
                    [showExample]="false" [showPrefixPadding]="false" [showPrefixIcon]="false"
                    (values)="locationChangeF($event)">
                  </app-location-selector>
                </div>
               
               
              </div>
        </div>
        <div class="col-12 form-input mb-3">
          <label class="mt-2 form-label">
           Property Type <span class="text-danger">*</span>
          </label>
          <select class="form-control" formControlName="properties_type" name="" id="">
              <option value="">Select your property types</option>
              <option value="house">House</option>
              <option value="Apartment">Apartment</option>
              <option value="first-class">Serviced Apartments</option>
          </select>
      </div>
      <div class="col-12 form-input mb-3">
        <label class="mt-2 form-label">
         Number of rooms <span class="text-danger">*</span>
        </label>
        <app-input formCtrlName="number_of_bedroom" [label]="'Enter number of bedrooms'" inputNumber [formGrp]="form" [required]="true">
        </app-input>
    </div>
    <div class="col-12 form-input ">
          
      <app-input-list-group [lists]="form.value.amenities" [formData]="otherFacilitiesData.form"
      [formGrp]="form" formCtrlName="amenities" (removedElement)="getRemovedRule($event)" ></app-input-list-group>

    </div>
        <div class="form-group mb-3">
            <label class=" form-label">
              Duration <span class="text-danger">*</span>
            </label>
            <div class="row">
                <div class="col-6 form-input">
                    <app-input [min]="minDate" formCtrlName="move_in_date" [label]="'Date'" [formGrp]="form" (changeEvent)="getDate($event)" date [required]="true">
                    </app-input>
                </div>
                <div class="col-6 form-input ">
            
                    <app-input [min]="minDate" formCtrlName="duration" [label]="'Date'" [formGrp]="form" date [required]="true">
                    </app-input>
                </div>
               
              </div>
        </div>
        <!-- <div class="form-group mb-3">
            <label class=" form-label">
              Move in Date <span class="text-danger">*</span>
            </label>
                <div class="form-input">
                    <app-input [min]="minDate" formCtrlName="move_in_date" [label]="'Date'" [formGrp]="form" (changeEvent)="getDate($event)" date [required]="true">
                    </app-input>
                </div>
         </div> -->
        
        
        <div class="mb-3 ">
           
            <label class="mt-2 form-label form-toggle">
              Additional Request
            </label>
            <textarea formControlName="additional_requests" placeholder="Any special requests or preferences, such as pet-friendly accommodations or proximity to specific amenities" class="form-control form-input booking-text-area text-body"
              cols="10" rows="5"></textarea>
        
            
        </div>
        <app-button 
                    class="book-btn"
                    [disabled]="form.invalid"
                    (click)="submit()"
                    [className]="'w-100'" warning>
                    {{loading ? 'Loading...': 'Submit'}}
                  </app-button>
    </form>


  </div>
  